import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { FontText } from './FontText';

interface TocItem {
  id: string;
  title: string;
}

interface TableOfContentsProps {
  items: TocItem[];
}

export const TableOfContents: React.FC<TableOfContentsProps> = ({ items }) => {
  const { theme } = useTheme();

  const handleClick = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const styles: Record<string, React.CSSProperties> = {
    container: {
      backgroundColor: theme.colors.surface,
      borderRadius: 12,
      padding: 20,
      marginBottom: 40,
      border: `1px solid ${theme.colors.overlay}`,
    },
    title: {
      color: theme.colors.text,
      marginBottom: 16,
    },
    list: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    item: {
      marginBottom: 8,
    },
    link: {
      color: theme.colors.textSecondary,
      textDecoration: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '4px 0',
      transition: 'color 0.2s',
    },
    bullet: {
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: theme.colors.accent,
      flexShrink: 0,
    },
  };

  return (
    <div style={styles.container}>
      <FontText h4 style={styles.title}>
        Table of Contents
      </FontText>
      <ul style={styles.list}>
        {items.map(item => (
          <li key={item.id} style={styles.item}>
            <a
              onClick={() => handleClick(item.id)}
              style={styles.link}
              onMouseEnter={e => {
                e.currentTarget.style.color = theme.colors.text;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.color = theme.colors.textSecondary;
              }}
            >
              <div style={styles.bullet} />
              <FontText normal>{item.title}</FontText>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
